export const DIALOG_ACTION = {
  OPEN: "DIALOG_OPEN",
  CLOSE: "DIALOG_CLOSE",
};

export const openDialog = () => ({
  type: DIALOG_ACTION.OPEN,
});

export const closeDialog = () => ({
  type: DIALOG_ACTION.CLOSE,
});
